import { render, staticRenderFns } from "./CampaignOverview.vue?vue&type=template&id=b991690a&"
import script from "./CampaignOverview.vue?vue&type=script&lang=js&"
export * from "./CampaignOverview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignOverview.vue?vue&type=style&index=0&id=b991690a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports